'use strict';

angular.module('app').factory('FoodService', FoodService);

FoodService.$inject = ['ApiService', 'utilService'];

function FoodService(ApiService, utilService) {
    return {
        getAllFoods: function (type) {
            return ApiService.get('api/food/' + type).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        getAllFoods114: function (type, prms) {
            return ApiService.get('api/1.1.4/food/' + type, prms).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        getAllFoods114Search: function (type, prms) {
            return ApiService.get('api/1.1.4/food/' + type + '/search', prms).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        getOneFood: function (id) {
            return ApiService.get('api/web/food/' + id).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        removeOneFood: function (id) {
            return ApiService.delete('api/food/' + id).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        getAllMicroNutrients: function () {
            return ApiService.get('api/web/food/micro-nutrient/get-all').then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        getAllMeasurements: function () {
            return ApiService.get('api/measurements').then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        getAllTags: function () {
            return ApiService.get('api/web/food/tags/get-all').then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        getTableForScores: function (scoreType) {
            return ApiService.get('api/super/score-table/' + scoreType).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        updateTableForScores: function (scoreType, data) {
            return ApiService.put('api/super/score-table/' + scoreType, data).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        updateTags: function (id, prms) {
            return ApiService.post('api/web/food/update-tags/' + id, null, prms).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        updateMicroNutrient: function (id, data) {
            return ApiService.post('api/web/food/update-micro-nutrients/' + id, data).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        updateRecommended: function (id, prms) {
            return ApiService.put('api/web/food/recommended/' + id, null, prms).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        addFood: function (data, prms) {
            var url = utilService.getLoggedInUserData().role === 'CUSTOMER' ? 'api/food/manual' : 'api/web/food/manual';
            return ApiService.post(url, data, prms).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        updateFood: function (id, data, prms) {
            return ApiService.put('api/1.2.0/food/' + id, data, prms).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        searchFoods: function (prms) {
            return ApiService.get('api/food/search', prms).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        },
        getBrands: function () {
            return ApiService.get('api/food/brands').then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        }
    };
}

